import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import './style.scss';
import { rebootGateway } from './actions';

const RebootGatewayComponent = ({ show, close, gatewayID }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();

    const content = <div className='reboot-gateway__content'>
        <p className='reboot-gateway__content-text'>{translate('ABB.Powertrain.Frontend.gatewayRebootDescription')}</p>
    </div>;

    const getRebootGatewayTitle = <h1 className='reboot-gateway__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='reboot-gateway__title-text'>{translate('ABB.Powertrain.Frontend.gatewayRebootGatewayTitle')}</span>
    </h1>;
    return <GeneralDialog
        show={show}
        close={close}
        title={getRebootGatewayTitle}
        id='reboot-gateway-dialog'
        dialogClassName='reboot-gateway__dialog'
        closeButton={true}
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
        }}
        acceptButtonProps={{
            text: translate('ABB.Powertrain.Frontend.gatewayRebootGatewayButtonLabel'),
            onClick: () => {
                dispatch(rebootGateway(gatewayID));
                close();
            }
        }}
    >
        {content}
    </GeneralDialog>;
};

RebootGatewayComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.string,
};

export default RebootGatewayComponent;
